module.exports = __webpack_public_path__ + "static/media/webdesign-services-img42.f3a29ac0.jpg";